import React from 'react';
import { motion } from 'framer-motion';
import LukIkon from './LukIkon';

const getAnimation = (slideInFromLeft: boolean) => ( show:boolean ) => {
	if (slideInFromLeft) {
		return {
			right: 'auto',
			left: show ? 0 : '-100%'
			// display: show ? 'block'  : 'none'

		};
	}

	return {
		left: 'auto',
		right: show ? 0 : '-100%'
		// display: show ? 'block'  : 'none'

	};
};

const SlideInText = ({ text, show, onClose, slideInFromLeft }) => {
	const animation = React.useCallback(getAnimation(slideInFromLeft), [slideInFromLeft]);
	// const animation =  getAnimation(slideInFromLeft)
	return (
		<>
			<motion.button
				className="meddelelse__info-text-overlay"
				onClick={ onClose }
				animate={ { opacity: show ? 0.2 : 0, display: show ? 'block' : 'none' } }
				transition={ {
					ease:'easeIn'
				} }
			/>
			<motion.div
				animate={ animation(show) }
				initial={ false }
				transition={ {
					ease:'easeIn'
				} }
				className="meddelelser__info-text-wrapper"
			>
				<div className="meddelelse__info-text">
					<button className="meddelelse__info-text-luk" onClick={ onClose }><LukIkon /></button>
					<section className="meddelelse__info-text-content" dangerouslySetInnerHTML={ { __html: text } } />
					<div
						className="meddelelse__info-text-gradient"
						/** Er noed til at saette det inline da bourbon modvirker gradients med opacity */
						style={ {
							background: 'linear-gradient(0deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%)'
						} }
					/>
				</div>
			</motion.div>
		</>
	);
};

export default SlideInText;
